import { View } from "react-native";
import { styles } from "../theme/styles";

const Spacer = () => {
  return <View style={styles.flex1} />;
};

export default Spacer;
